import cx from 'classnames';
import React, { useRef, useMemo, useCallback } from 'react';
import { CSSTransition } from 'react-transition-group';
import { withNativeProps } from '../../utils/native-props';
import { mergeProps } from '../../utils/with-default-props';
import { useInitialized } from '../../utils/use-initialized';
import { renderToContainer } from '../../utils/render-to-container';
import { useLockScroll } from '../../utils/use-lock-scroll';
import { useCssVar } from '../../utils/use-css-var';
var classPrefix = 'pen-mask';
var opacityRecord = {
  "default": 0.6,
  thin: 0.4,
  thick: 0.8
};
var defaultProps = {
  visible: true,
  destroyOnClose: false,
  forceRender: false,
  color: 'black',
  opacity: 'default',
  disableBodyScroll: true,
  getContainer: null
};
export var Mask = function Mask(p) {
  var _cx;

  var props = mergeProps(defaultProps, p);
  var className = cx(classPrefix, props.className, (_cx = {}, _cx[classPrefix + "-hidden"] = !props.visible, _cx));
  var initialized = useInitialized(props.visible || props.forceRender);
  var ref = useRef(null);
  var animDuration = parseInt(useCssVar('--pen-animate-duration'), 10);
  var background = useMemo(function () {
    var _a;

    var opacity = (_a = opacityRecord[props.opacity]) !== null && _a !== void 0 ? _a : props.opacity;
    var rgb = props.color === 'white' ? '255, 255, 255' : '0, 0, 0';
    return "rgba(" + rgb + ", " + opacity + ")";
  }, [props.color, props.opacity]);
  var onMaskClick = props.onMaskClick;
  var handleClick = useCallback(function (evt) {
    if (evt.currentTarget === evt.target) {
      onMaskClick === null || onMaskClick === void 0 ? void 0 : onMaskClick(evt);
    }
  }, [onMaskClick]);
  useLockScroll(ref, Boolean(props.visible && props.disableBodyScroll));
  var node = /*#__PURE__*/React.createElement(CSSTransition, {
    "in": props.visible,
    timeout: animDuration,
    classNames: classPrefix,
    onEntered: props.afterShow,
    onExited: props.afterClose,
    unmountOnExit: props.destroyOnClose
  }, withNativeProps(props, /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: className,
    onClick: handleClick,
    style: Object.assign({
      background: background
    }, props.style)
  }, /*#__PURE__*/React.createElement("div", {
    className: classPrefix + "-content"
  }, initialized && props.children))));
  return renderToContainer(props.getContainer, node);
};